import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { Supplier } from '../../../warehouse/supplier/supplier';
import { Landkreis } from '../landkreis';

@Component({
    selector: 'kiene-edit-dialog',
    templateUrl: './edit-dialog.component.html',
    styleUrls: ['./edit-dialog.component.scss'],
})
export class EditLandkreisDialogComponent implements OnInit {
    landkreis = new Landkreis();

    vetAmt = new Supplier();
    ueberwachungsbehoerde = new Supplier();

    constructor(
        public dialogRef: MatDialogRef<EditLandkreisDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data,
        private api: KieneTableService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private notification: MessageService,
    ) {
        this.landkreis = data.landkreis;
    }

    ngOnInit() {
        this.loadVetAmt();
        this.loadUeberwachungsbehoerde();
    }

    loadVetAmt() {
        if (this.landkreis.lieferant_id_veterinaeramt) {
            this.api
                .getOne(
                    this.apiBaseUrl + 'lieferant/read_one.php',
                    'lieferant_id',
                    this.landkreis.lieferant_id_veterinaeramt.toString(),
                )
                .subscribe(response => {
                    this.vetAmt = response;
                });
        }
    }

    setVetAmt(supplier: Supplier) {
        this.landkreis.lieferant_id_veterinaeramt = supplier.lieferant_id;
    }

    loadUeberwachungsbehoerde() {
        if (this.landkreis.lieferant_id_ueberwachungsbehoerde) {
            this.api
                .getOne(
                    this.apiBaseUrl + 'lieferant/read_one.php',
                    'lieferant_id',
                    this.landkreis.lieferant_id_ueberwachungsbehoerde.toString(),
                )
                .subscribe(response => {
                    this.ueberwachungsbehoerde = response;
                });
        }
    }

    setUeberwachungsbehoerde(supplier: Supplier) {
        this.landkreis.lieferant_id_ueberwachungsbehoerde = supplier.lieferant_id;
    }

    save() {
        this.api.updateEntity(this.apiBaseUrl + 'landkreis/update.php', this.landkreis).subscribe(
            () => {
                this.dialogRef.close();
            },
            error => {
                this.notification.errorMessage('', error);
            },
        );
    }
}
